import { useState } from "react";

const ProfileCard = ({ profile, setProfile, onSaved }) => {
  const [editing, setEditing] = useState(false);
  const [draftPhone, setDraftPhone] = useState(profile.phone || "");

  const startEdit = () => {
    setDraftPhone(profile.phone || "");
    setEditing(true);
  };

  const cancelEdit = () => {
    setDraftPhone(profile.phone || "");
    setEditing(false);
  };

  const handleSaveProfile = () => {
    const next = { ...profile, phone: draftPhone.trim() };
    setProfile(next);
    setEditing(false);
    onSaved?.({
      title: "Profile updated",
      message: "Your contact details were saved successfully.",
    });
  };

  const phoneDisplay = [profile.countryCode, profile.phone].filter(Boolean).join(" ") || "Not added";

  return (
    <div className="settings-form">
      <div className="settings-grid">
        <Field label="User ID" value={profile.userId || "—"} locked />
        <Field label="Name" value={profile.name || "—"} locked />
        <Field label="Email" value={profile.email || "—"} locked />
        <div className="settings-field">
          <span className="settings-field__label">Phone</span>
          {editing ? (
            <input
              type="tel"
              name="phone"
              value={draftPhone}
              onChange={(event) => setDraftPhone(event.target.value)}
              className="settings-input"
              placeholder="Add a phone number"
              autoFocus
            />
          ) : (
            <div className="settings-field__value">{phoneDisplay}</div>
          )}
        </div>
        <Field label="Organization" value={profile.organization || "—"} locked />
        <Field label="Organization ID" value={profile.organizationID || "—"} locked />
      </div>

      {/* <div className="settings-actions">
        {editing ? (
          <>
            <button type="button" className="settings-btn settings-btn--ghost" onClick={cancelEdit}>
              Cancel
            </button>
            <button type="button" className="settings-btn settings-btn--primary" onClick={handleSaveProfile}>
              Save profile
            </button>
          </>
        ) : (
          <button type="button" className="settings-btn settings-btn--primary" onClick={startEdit}>
            <i className="bi bi-pencil" />
            Edit phone
          </button>
        )}
      </div> */}
    </div>
  );
};

const Field = ({ label, value, locked }) => (
  <div className="settings-field">
    <span className="settings-field__label">
      {label}
      {locked && <em>Read only</em>}
    </span>
    <div className="settings-field__value">{value}</div>
  </div>
);

export default ProfileCard;
